import { createSlice } from "@reduxjs/toolkit";

const initialWorkFlowState = {
  workFlow: [],
  listLoading: false,
  actionLoading: false,
  selectedWorkFlow: null,
};

export const workFlowSlice = createSlice({
  name: "workFlowSlice",
  initialState: initialWorkFlowState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    stopCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    workFlowList: (state, action) => {
      state.workFlow = action?.payload;
      state.actionLoading = false;
      state.listLoading = false;
    },
    selectedWorkFlowList: (state, action) => {
      state.selectedWorkFlow = action.payload;
      state.listLoading = false;
    },
  },
});
